var ButtonType = /* @__PURE__ */ ((ButtonType2) => {
  ButtonType2["CUSTOM"] = "custom";
  ButtonType2["FILES"] = "file";
  ButtonType2["TOGGLE"] = "toggle";
  ButtonType2["PANEL"] = "panel";
  ButtonType2["INLINE_PANEL"] = "inline-panel";
  ButtonType2["EXTERNAL_MODAL"] = "external-modal";
  ButtonType2["DROPDOWN"] = "dropdown";
  ButtonType2["SEPARATOR"] = "separator";
  ButtonType2["SIZE_ORIGINAL"] = "size-original";
  ButtonType2["SIZE_CONTENT_CENTER"] = "size-content-center";
  ButtonType2["SIZE_SMALL_CENTER"] = "size-small-center";
  ButtonType2["SIZE_SMALL_LEFT"] = "size-small-left";
  ButtonType2["SIZE_SMALL_RIGHT"] = "size-small-right";
  ButtonType2["ALIGN_LEFT"] = "align-left";
  ButtonType2["ALIGN_RIGHT"] = "align-right";
  ButtonType2["ALIGN_CENTER"] = "align-center";
  ButtonType2["SIZE_CONTENT"] = "size-content";
  ButtonType2["SIZE_FULL_WIDTH"] = "size-full-width";
  ButtonType2["SIZE_SMALL"] = "size-small";
  ButtonType2["SIZE_MEDIUM"] = "size-medium";
  ButtonType2["SIZE_LARGE"] = "size-large";
  ButtonType2["TEXT_ALIGN_LEFT"] = "alignment-left";
  ButtonType2["TEXT_ALIGN_CENTER"] = "alignment-center";
  ButtonType2["TEXT_ALIGN_RIGHT"] = "alignment-right";
  ButtonType2["WIDTH"] = "width";
  ButtonType2["HEIGHT"] = "height";
  ButtonType2["LINK"] = "link";
  ButtonType2["SPOILER"] = "spoiler";
  ButtonType2["DELETE"] = "delete";
  ButtonType2["LINK_PREVIEW"] = "link-preview";
  ButtonType2["VIDEO_SETTINGS"] = "video-settings";
  ButtonType2["FILE_UPLOAD_SETTINGS"] = "file-upload-settings";
  ButtonType2["AUDIO_SETTINGS"] = "audio-settings";
  return ButtonType2;
})(ButtonType || {});
var ModifierKey = /* @__PURE__ */ ((ModifierKey2) => {
  ModifierKey2["COMMAND"] = "command";
  ModifierKey2["CTRL"] = "ctrl";
  ModifierKey2["OPTION"] = "option";
  ModifierKey2["SHIFT"] = "shift";
  ModifierKey2["ALT"] = "alt";
  return ModifierKey2;
})(ModifierKey || {});
var ToolbarType = /* @__PURE__ */ ((ToolbarType2) => {
  ToolbarType2["SIDE"] = "SIDE";
  ToolbarType2["MOBILE"] = "MOBILE";
  ToolbarType2["FOOTER"] = "FOOTER";
  ToolbarType2["STATIC"] = "STATIC";
  ToolbarType2["INLINE"] = "INLINE";
  ToolbarType2["PLUGIN"] = "PLUGIN";
  ToolbarType2["FORMATTING"] = "FORMATTING";
  ToolbarType2["INSERT_PLUGIN"] = "INSERT_PLUGIN";
  ToolbarType2["TEXT"] = "ALL-TEXT-TOOLBARS";
  ToolbarType2["SHORTCUT"] = "SHORTCUT";
  ToolbarType2["LINK"] = "LINK";
  ToolbarType2["EXTERNAL"] = "EXTERNAL";
  ToolbarType2["PLUGIN_MENU"] = "PLUGIN_MENU";
  ToolbarType2["MEGA"] = "MEGA";
  ToolbarType2["EMPTY"] = "EMPTY";
  return ToolbarType2;
})(ToolbarType || {});
var DisplayMode = /* @__PURE__ */ ((DisplayMode2) => {
  DisplayMode2["NORMAL"] = "NORMAL";
  DisplayMode2["FLOATING"] = "FLOATING";
  return DisplayMode2;
})(DisplayMode || {});
var DecorationMode = /* @__PURE__ */ ((DecorationMode2) => {
  DecorationMode2["PREPEND"] = "PREPEND";
  DecorationMode2["WRAP"] = "WRAP";
  DecorationMode2["APPEND"] = "APPEND";
  return DecorationMode2;
})(DecorationMode || {});

export { ButtonType, DecorationMode, DisplayMode, ModifierKey, ToolbarType };
//# sourceMappingURL=toolbarEnums.js.map
